export default __webpack_public_path__ + "static/media/alert.a2220f20.svg";